import { render, staticRenderFns } from "./EditPlanoUsuarioPublico.vue?vue&type=template&id=7c622518&"
import script from "./EditPlanoUsuarioPublico.vue?vue&type=script&lang=js&"
export * from "./EditPlanoUsuarioPublico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports